export default __webpack_public_path__ + "static/media/White.28863bb1.png";